import React from "react"
import styled from "styled-components"

import AppStoreButton from "~/public/static/images/svg/AppStoreButton.svg"
import GooglePlayButton from "~/public/static/images/svg/GooglePlayButton.svg"

import SocialMedia from "~/components/dashboard/Layout/Footer/logos/SocialMedia"
import Spacer from "~/components/Spacer"

const Group = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 10px 0;
`

const DownloadButton = styled.img`
  height: 46px;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`

const OutlinkImages = ({ isStateAffiliatedWithWinitLaw }) => {
  if (isStateAffiliatedWithWinitLaw) return null
  return (
    <Row>
      <Group>
        <a href="https://itunes.apple.com/us/app/winit-fight-your-tickets/id929918279">
          <DownloadButton src={AppStoreButton} alt="App Store" />
        </a>
        <Spacer desktop={10} mobile={10} />
        <Spacer direction="width" desktop={24} mobile={24} />
        <a href="https://play.google.com/store/apps/details?id=com.winitllc.ticketfighter">
          <DownloadButton src={GooglePlayButton} alt="Google Play" />
        </a>
      </Group>
      <Group>
        <SocialMedia />
      </Group>
    </Row>
  )
}

export default OutlinkImages
